export default "__VITE_ASSET__2e53fd99__"